/**
 * 403 Forbidden page.
 *
 * Rendered when the BFF rejects a request with HTTP 403 (RBAC
 * denial) — the API client navigates here via the router. Per
 * Flow O (Permission denied) — generic copy; no leakage of
 * required roles or internal endpoint paths.
 *
 * The BFF's `require_roles` dependency already emitted a
 * ``user.permission.denied`` audit event before raising 403
 * (REQ-AUTH-039); no client-side audit event needed.
 */
import { Link } from "react-router";

export function ForbiddenPage(): React.ReactElement {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-2 text-foreground">
      <p className="text-sm">You don't have access to this surface.</p>
      <Link to="/" className="text-body-sm underline text-brand">
        Back to map
      </Link>
    </div>
  );
}
